import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "page-title d-flex align-items-center flex-wrap me-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Thông tin chi tiết ứng viên", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-400 border-start mx-4" }, null, -1)
const _hoisted_5 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1" }
const _hoisted_6 = { class: "breadcrumb-item text-muted" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/dashboard",
  class: "text-muted text-hover-primary"
}, "Dashboard", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_10 = { class: "breadcrumb-item text-muted" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_12 = { class: "d-flex flex-column flex-xl-row" }
const _hoisted_13 = { class: "flex-column flex-lg-row-auto w-100 w-xl-300px mb-10 umt-sidebar" }
const _hoisted_14 = { class: "card mb-5 mb-xl-8" }
const _hoisted_15 = {
  key: 0,
  class: "alert alert-danger d-flex flex-column p-3 mb-4"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold mb-1" }, "⚠ CMND/CCCD trùng!", -1)
const _hoisted_17 = { class: "fs-8" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "d-flex flex-column" }
const _hoisted_21 = { class: "text-center mb-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-100px symbol-circle mb-3 mx-auto" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/avatars/blank.png",
    alt: "image"
  })
], -1)
const _hoisted_23 = { class: "fs-3 fw-bolder text-gray-900 text-break" }
const _hoisted_24 = {
  key: 0,
  class: "d-flex flex-wrap justify-content-center gap-2 mt-2"
}
const _hoisted_25 = { class: "badge badge-light-primary fw-bold" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-4" }, null, -1)
const _hoisted_27 = { class: "d-flex align-items-baseline gap-2 mb-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 text-muted min-w-80px flex-shrink-0" }, "Điện thoại", -1)
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "d-flex align-items-baseline gap-2 mb-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 text-muted min-w-80px flex-shrink-0" }, "Email", -1)
const _hoisted_32 = ["href"]
const _hoisted_33 = { class: "d-flex align-items-baseline gap-2 mb-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 text-muted min-w-80px flex-shrink-0" }, "CCCD", -1)
const _hoisted_35 = { class: "fs-8 fw-semibold text-gray-800 text-break ms-auto text-end" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-4" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted text-uppercase fw-bold fs-8 mb-3" }, "Hồ sơ", -1)
const _hoisted_38 = { class: "d-flex align-items-baseline gap-2 mb-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 text-muted min-w-80px flex-shrink-0" }, "HS xét tuyển", -1)
const _hoisted_40 = { class: "ms-auto text-end" }
const _hoisted_41 = ["href", "title"]
const _hoisted_42 = {
  key: 1,
  class: "fs-8 text-muted"
}
const _hoisted_43 = { class: "d-flex align-items-baseline gap-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 text-muted min-w-80px flex-shrink-0" }, "HS nhập học", -1)
const _hoisted_45 = { class: "ms-auto text-end" }
const _hoisted_46 = ["href", "title"]
const _hoisted_47 = { class: "fs-8 fw-semibold text-primary text-nowrap" }
const _hoisted_48 = {
  key: 0,
  class: "badge badge-light-success fs-9"
}
const _hoisted_49 = {
  key: 1,
  class: "badge badge-light-warning fs-9"
}
const _hoisted_50 = {
  key: 2,
  class: "badge badge-light fs-9"
}
const _hoisted_51 = {
  key: 1,
  class: "d-inline-flex align-items-center gap-1 ms-2"
}
const _hoisted_52 = { class: "fs-8 fw-semibold text-gray-500 text-nowrap" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light fs-9" }, "Chưa mở hồ sơ", -1)
const _hoisted_54 = {
  key: 1,
  class: "fs-8 text-muted"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-4" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted text-uppercase fw-bold fs-8 mb-3" }, "Salesforce", -1)
const _hoisted_57 = { class: "d-flex align-items-center gap-2 mb-2" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 text-muted min-w-80px flex-shrink-0" }, "Lead", -1)
const _hoisted_59 = ["href"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill text-success fs-9 me-1" }, null, -1)
const _hoisted_61 = {
  key: 1,
  class: "badge badge-light ms-auto flex-shrink-0"
}
const _hoisted_62 = { class: "d-flex align-items-center gap-2" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 text-muted min-w-80px flex-shrink-0" }, "Opportunity", -1)
const _hoisted_64 = ["href"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill text-success fs-9 me-1" }, null, -1)
const _hoisted_66 = {
  key: 1,
  class: "badge badge-light ms-auto flex-shrink-0"
}
const _hoisted_67 = {
  key: 0,
  class: "d-flex align-items-center gap-2 mt-2"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "fs-8 text-muted min-w-80px flex-shrink-0" }, "Stage", -1)
const _hoisted_69 = { class: "d-flex align-items-center gap-1 ms-auto text-nowrap" }
const _hoisted_70 = ["title"]
const _hoisted_71 = {
  key: 1,
  class: "fs-8 text-muted",
  title: "Chưa đọc stage từ Salesforce lần nào"
}
const _hoisted_72 = ["title"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-4" }, null, -1)
const _hoisted_74 = { class: "d-flex gap-3" }
const _hoisted_75 = { class: "svg-icon svg-icon-2 me-1" }
const _hoisted_76 = { class: "svg-icon svg-icon-2 me-1" }
const _hoisted_77 = { class: "svg-icon svg-icon-2 me-1" }
const _hoisted_78 = { class: "card-header" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder fs-6 text-gray-600 text-uppercase m-0" }, "Điều kiện tốt nghiệp THPT")
], -1)
const _hoisted_80 = { class: "mt-3 w-100 mb-5" }
const _hoisted_81 = {
  key: 0,
  class: "fv-row w-100 text-end"
}
const _hoisted_82 = {
  key: 1,
  class: "fv-row w-100 text-end"
}
const _hoisted_83 = {
  key: 1,
  class: "fv-row w-100 text-end"
}
const _hoisted_84 = { class: "text-center mb-5 mb-xl-8" }
const _hoisted_85 = ["disabled", "title"]
const _hoisted_86 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_87 = {
  key: 0,
  class: "text-muted fs-8 fst-italic mt-2"
}
const _hoisted_88 = { class: "flex-lg-row-fluid ms-lg-8" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-octagon-fill text-danger fs-4 me-3 flex-shrink-0" }, null, -1)
const _hoisted_90 = { class: "fs-7 text-gray-800" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Cảnh báo tốt nghiệp:", -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary fw-semibold text-nowrap ms-1" }, [
  /*#__PURE__*/_createTextVNode("Xem mục điểm "),
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right" })
], -1)
const _hoisted_93 = { class: "bg-white rounded-top nav nav-tabs-custom gap-2 fw-semibold align-items-center" }
const _hoisted_94 = { class: "nav-item" }
const _hoisted_95 = { class: "nav-item" }
const _hoisted_96 = { class: "nav-item" }
const _hoisted_97 = { class: "nav-item" }
const _hoisted_98 = { class: "svg-icon svg-icon-3" }
const _hoisted_99 = { class: "svg-icon svg-icon-3" }
const _hoisted_100 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2 me-1" }, null, -1)
const _hoisted_102 = {
  key: 1,
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_103 = {
  class: "tab-pane bg-white rounded-bottom fade",
  id: "kt_customer_view_personal_infor",
  role: "tabpanel"
}
const _hoisted_104 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_105 = {
  class: "tab-pane bg-white rounded-bottom fade show active",
  id: "kt_customer_view_learning_infor",
  role: "tabpanel"
}
const _hoisted_106 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_107 = {
  class: "tab-pane bg-white rounded-bottom fade",
  id: "kt_customer_view_admission_profile",
  role: "tabpanel"
}
const _hoisted_108 = {
  key: 0,
  class: "px-9 pb-9"
}
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-6" }, null, -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "umt-section-hdr fs-6 text-uppercase mb-4 pb-2 border-bottom border-gray-200" }, "Học bổng của ứng viên", -1)
const _hoisted_111 = { class: "table-responsive" }
const _hoisted_112 = { class: "table table-row-dashed table-row-gray-200 align-middle gy-3 mb-0 umt-table" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-bottom border-gray-200" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "Học bổng đăng ký"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "Học bổng cấp"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "Ngành nhận"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "Giá trị"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "Số / Ngày QĐ"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-nowrap" }, "Trạng thái"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-80px" })
  ])
], -1)
const _hoisted_114 = { class: "fw-semibold text-gray-800" }
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { key: 1 }
const _hoisted_117 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_118 = { key: 0 }
const _hoisted_119 = { class: "text-end text-nowrap" }
const _hoisted_120 = ["onClick"]
const _hoisted_121 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-circle fs-7" }, null, -1)
const _hoisted_122 = [
  _hoisted_121
]
const _hoisted_123 = ["onClick"]
const _hoisted_124 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil fs-7" }, null, -1)
const _hoisted_125 = [
  _hoisted_124
]
const _hoisted_126 = ["onClick"]
const _hoisted_127 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-7" }, null, -1)
const _hoisted_128 = [
  _hoisted_127
]
const _hoisted_129 = {
  key: 1,
  class: "text-muted fs-8 fst-italic",
  title: "Ứng viên chưa có hồ sơ đăng ký xét tuyển — cần tạo hồ sơ trước khi phê duyệt/chỉnh sửa học bổng"
}
const _hoisted_130 = {
  class: "tab-pane fade",
  id: "kt_customer_view_admission_procedures",
  role: "tabpanel"
}
const _hoisted_131 = { class: "bg-white rounded-bottom" }
const _hoisted_132 = { class: "card login-info-card umt-form" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 umt-card-header-tight" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder fs-6 text-gray-600 text-uppercase m-0" }, "Thông tin đăng nhập")
  ])
], -1)
const _hoisted_134 = { class: "card-body pt-0" }
const _hoisted_135 = {
  class: "row",
  style: {"align-items":"end"}
}
const _hoisted_136 = { class: "col-12 col-md-7" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-1" }, [
  /*#__PURE__*/_createTextVNode("Tên đăng nhập "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "(dùng email hoặc CCCD)")
], -1)
const _hoisted_138 = { class: "d-flex flex-column flex-md-row align-items-md-center gap-2 mb-3" }
const _hoisted_139 = { class: "input-group flex-fill" }
const _hoisted_140 = { class: "input-group-text" }
const _hoisted_141 = { class: "svg-icon svg-icon-3" }
const _hoisted_142 = ["value"]
const _hoisted_143 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold fs-7 px-1 text-center" }, "Or", -1)
const _hoisted_144 = { class: "input-group flex-fill" }
const _hoisted_145 = { class: "input-group-text" }
const _hoisted_146 = { class: "svg-icon svg-icon-3" }
const _hoisted_147 = ["value"]
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-md-flex col-md-5" }, null, -1)
const _hoisted_149 = { class: "col-12 col-md-5" }
const _hoisted_150 = { class: "input-group mb-3" }
const _hoisted_151 = { class: "input-group-text" }
const _hoisted_152 = { class: "svg-icon svg-icon-3" }
const _hoisted_153 = ["value"]
const _hoisted_154 = { class: "svg-icon svg-icon-xl" }
const _hoisted_155 = { class: "col-12 col-md-7" }
const _hoisted_156 = { class: "svg-icon svg-icon-3" }
const _hoisted_157 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_WidgetStaffLecturerChild = _resolveComponent("WidgetStaffLecturerChild")!
  const _component_WidgetAssignUserGroup = _resolveComponent("WidgetAssignUserGroup")!
  const _component_WidgetComment = _resolveComponent("WidgetComment")!
  const _component_WidgetAssign = _resolveComponent("WidgetAssign")!
  const _component_PersonalInfor = _resolveComponent("PersonalInfor")!
  const _component_LearningInfor = _resolveComponent("LearningInfor")!
  const _component_AdmissionProfile = _resolveComponent("AdmissionProfile")!
  const _component_ScholarshipRegisterDrawer = _resolveComponent("ScholarshipRegisterDrawer")!
  const _component_ScholarshipApproveModal = _resolveComponent("ScholarshipApproveModal")!
  const _component_AdmissionProcedures = _resolveComponent("AdmissionProcedures")!
  const _component_ModalDeleteAndReason = _resolveComponent("ModalDeleteAndReason")!
  const _component_ModalChooseMajor = _resolveComponent("ModalChooseMajor")!
  const _component_ModalChooseApplicants = _resolveComponent("ModalChooseApplicants")!
  const _component_ModalRunAnalysis = _resolveComponent("ModalRunAnalysis")!
  const _component_ModalEditInput = _resolveComponent("ModalEditInput")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("ul", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8)), [
            [_directive_permission, [_ctx.Permission.DASHBOARD_VIEW, _ctx.Permission.DASHBOARD]]
          ]),
          _hoisted_9,
          _createElementVNode("li", _hoisted_10, [
            (_ctx.$route.query.from === 'lienthong')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/danhsachdangkylienthong",
                  class: "text-muted text-hover-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Danh sách ứng viên liên thông")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/danhsachungvien",
                  class: "text-muted text-hover-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Danh sách ứng viên")
                  ]),
                  _: 1
                }))
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-light ms-auto umt-btn-32",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, [
          _hoisted_11,
          _createTextVNode("Quay lại ")
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass(["card-body py-5", _ctx.dataCustomer?.status.state == 'processing' ? 'bg-light-warning' : ''])
            }, [
              (_ctx.idCardDuplicate.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createTextVNode("CCCD "),
                      _createElementVNode("b", null, _toDisplayString(_ctx.dataCustomer.idCard), 1),
                      _createTextVNode(" đang trùng với: "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.idCardDuplicate, (s, i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: s.id
                        }, [
                          _createElementVNode("a", {
                            href: `/danhsachungvien/${s.id}?tab=personal`,
                            class: "fw-bold text-danger text-decoration-underline"
                          }, _toDisplayString(s.fullName), 9, _hoisted_18),
                          (i < _ctx.idCardDuplicate.length - 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, ", "))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.dataCustomer.fullName), 1),
                  (_ctx.dataCustomer.studentcode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, "MSSV: " + _toDisplayString(_ctx.dataCustomer.studentcode), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_26,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("a", {
                      href: `tel:${_ctx.dataCustomer.phone}`,
                      class: "fs-8 fw-semibold text-gray-800 text-hover-primary text-break ms-auto text-end"
                    }, _toDisplayString(_ctx.dataCustomer.phone || '—'), 9, _hoisted_29)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("a", {
                      href: `mailto:${_ctx.dataCustomer.email}`,
                      class: "fs-8 fw-semibold text-gray-800 text-hover-primary text-break ms-auto text-end"
                    }, _toDisplayString(_ctx.dataCustomer.email || '—'), 9, _hoisted_32)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.dataCustomer.idCard || '—'), 1)
                  ])
                ]),
                _hoisted_36,
                _createElementVNode("div", null, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("span", _hoisted_40, [
                      (_ctx.dataAdmission && _ctx.dataAdmission.length)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.dataAdmission, (hs) => {
                            return (_openBlock(), _createElementBlock("a", {
                              key: hs.id,
                              href: `/hosoungvien/${hs.id}`,
                              target: "_blank",
                              class: "fs-8 fw-semibold text-primary d-inline-block ms-2 text-nowrap",
                              title: `Mở hồ sơ ${hs.code} (tab mới)`
                            }, _toDisplayString(hs.code), 9, _hoisted_41))
                          }), 128))
                        : (_openBlock(), _createElementBlock("span", _hoisted_42, "—"))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("span", _hoisted_45, [
                      (_ctx.dataApplicant && _ctx.dataApplicant.length)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.dataApplicant, (ap) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: ap.id
                            }, [
                              (ap.applicantId)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: `/danhsachthutucnhaphoc/${ap.applicantId}`,
                                    target: "_blank",
                                    class: "d-inline-flex align-items-center gap-1 ms-2",
                                    title: `Mở hồ sơ nhập học ${ap.profileCode} (tab mới)`
                                  }, [
                                    _createElementVNode("span", _hoisted_47, _toDisplayString(ap.profileCode), 1),
                                    (ap.status == 'opened' && ap.applicantStatus == 'confirmed')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Đã xác nhận"))
                                      : (ap.status == 'opened')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Chưa xác nhận"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_50, "Đã hủy"))
                                  ], 8, _hoisted_46))
                                : (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                    _createElementVNode("span", _hoisted_52, _toDisplayString(ap.profileCode), 1),
                                    _hoisted_53
                                  ]))
                            ], 64))
                          }), 128))
                        : (_openBlock(), _createElementBlock("span", _hoisted_54, "—"))
                    ])
                  ])
                ]),
                _hoisted_55,
                _createElementVNode("div", null, [
                  _hoisted_56,
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    (_ctx.dataCustomer.leadid)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: `https://umthcm.lightning.force.com/lightning/r/Lead/${_ctx.dataCustomer.leadid}/view`,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          title: "Đã đẩy — mở Lead trên Salesforce",
                          class: "fs-8 fw-semibold text-gray-800 text-hover-primary text-nowrap ms-auto"
                        }, [
                          _hoisted_60,
                          _createTextVNode(_toDisplayString(_ctx.dataCustomer.leadid), 1)
                        ], 8, _hoisted_59))
                      : (_openBlock(), _createElementBlock("span", _hoisted_61, "Chưa đẩy"))
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _hoisted_63,
                    (_ctx.dataCustomer.opportunityid)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: `https://umthcm.lightning.force.com/lightning/r/Opportunity/${_ctx.dataCustomer.opportunityid}/view`,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          title: "Đã đẩy — mở Opportunity trên Salesforce",
                          class: "fs-8 fw-semibold text-gray-800 text-hover-primary text-nowrap ms-auto"
                        }, [
                          _hoisted_65,
                          _createTextVNode(_toDisplayString(_ctx.dataCustomer.opportunityid), 1)
                        ], 8, _hoisted_64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_66, "Chưa đẩy"))
                  ]),
                  (_ctx.dataCustomer.opportunityid)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                        _hoisted_68,
                        _createElementVNode("span", _hoisted_69, [
                          (_ctx.sfStageText())
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "fs-8 fw-semibold text-gray-800",
                                title: _ctx.sfStageTitle()
                              }, _toDisplayString(_ctx.sfStageText()), 9, _hoisted_70))
                            : (_openBlock(), _createElementBlock("span", _hoisted_71, "—")),
                          _createElementVNode("span", {
                            class: "cursor-pointer text-muted text-hover-primary",
                            title: _ctx.sfStageLoading ? 'Đang đọc...' : 'Đọc lại stage từ Salesforce',
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refreshSfStage()))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["bi fs-8", _ctx.sfStageLoading ? 'bi-hourglass-split' : 'bi-arrow-clockwise'])
                            }, null, 2)
                          ], 8, _hoisted_72)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_73,
                _createElementVNode("div", _hoisted_74, [
                  (!_ctx.dataCustomer.studentcode)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "btn btn-light-info btn-sm flex-fill d-flex align-items-center justify-content-center px-2 umt-btn-32",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.callChooseApplicant())),
                        title: "Tạo Mã SV"
                      }, [
                        _createElementVNode("span", _hoisted_75, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil023.svg" })
                        ]),
                        _createTextVNode(" Tạo mã SV ")
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "btn btn-light-primary btn-sm flex-fill d-flex align-items-center justify-content-center px-2 umt-btn-32",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.callSyncCRM())),
                    title: "Đẩy thông tin hiện tại lên Salesforce"
                  }, [
                    _createElementVNode("span", _hoisted_76, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil022.svg" })
                    ]),
                    _createTextVNode(" Đẩy lên Salesforce ")
                  ]),
                  (_ctx.dataCustomer.studentcode)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "btn btn-light-success btn-sm flex-fill d-flex align-items-center justify-content-center px-2 umt-btn-32",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fixSyncAdmApplicant && _ctx.fixSyncAdmApplicant(...args))),
                        title: "Đẩy thông tin hiện tại lên SIS"
                      }, [
                        _createElementVNode("span", _hoisted_77, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                        ]),
                        _createTextVNode(" Đẩy lên SIS ")
                      ])), [
                        [_directive_permission, [_ctx.Permission.STUDENT_EDIT, _ctx.Permission.STUDENT]]
                      ])
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["card card-flush py-4 mb-5 mb-xl-8", _ctx.isHighschool ? 'border border-dashed border-danger bg-light-danger' : ''])
          }, [
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _createElementVNode("div", _hoisted_80, [
                _createVNode(_component_el_select, {
                  class: "form-select-solid w-100",
                  placeholder: "Chọn điều kiện tốt nghiệp THPT",
                  modelValue: _ctx.dataCustomer.highschoolGraduation,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataCustomer.highschoolGraduation) = $event)),
                  ref: "statusGraduated",
                  disabled: !_ctx.isChangeStatusGraduated,
                  filterable: true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Chưa tốt nghiệp THPT",
                      value: "not_graduated"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Chưa tốt nghiệp THPT")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Giấy chứng nhận TNTT",
                      value: "temp_graduated"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Giấy chứng nhận TNTT")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Đã tốt nghiệp THPT",
                      value: "graduated"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Đã tốt nghiệp THPT")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              (_ctx.dataAdmission.length != 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (!_ctx.dataAdmission[0].isAppraised)
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_81, [
                          (_ctx.isChangeStatusGraduated)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "btn btn-sm btn-secondary min-w-100px me-2 umt-btn-32",
                                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancelStatusGraduated && _ctx.cancelStatusGraduated(...args)))
                              }, "Trở lại"))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", {
                            class: "btn btn-sm btn-primary min-w-100px umt-btn-32",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.changeStatusGraduated && _ctx.changeStatusGraduated(...args)))
                          }, _toDisplayString(_ctx.isChangeStatusGraduated ? "Lưu" : "Thay đổi"), 1)
                        ])), [
                          [_directive_permission, [_ctx.Permission.STUDENT_EDIT_GRADUATION, _ctx.Permission.STUDENT]]
                        ])
                      : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_82, [
                          (_ctx.isChangeStatusGraduated)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "btn btn-sm btn-secondary min-w-100px me-2 umt-btn-32",
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancelStatusGraduated && _ctx.cancelStatusGraduated(...args)))
                              }, "Trở lại"))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", {
                            class: "btn btn-sm btn-primary min-w-100px umt-btn-32",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.changeStatusGraduated && _ctx.changeStatusGraduated(...args)))
                          }, _toDisplayString(_ctx.isChangeStatusGraduated ? "Lưu" : "Thay đổi"), 1)
                        ])), [
                          [_directive_permission, [_ctx.Permission.ADMISSION_EDIT_GRADUATION, _ctx.Permission.ADMISSION]]
                        ])
                  ], 64))
                : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_83, [
                    (_ctx.isChangeStatusGraduated)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "btn btn-sm btn-secondary min-w-100px me-2 umt-btn-32",
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.cancelStatusGraduated && _ctx.cancelStatusGraduated(...args)))
                        }, "Trở lại"))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: "btn btn-sm btn-primary min-w-100px umt-btn-32",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.changeStatusGraduated && _ctx.changeStatusGraduated(...args)))
                    }, _toDisplayString(_ctx.isChangeStatusGraduated ? "Lưu" : "Thay đổi"), 1)
                  ])), [
                    [_directive_permission, [_ctx.Permission.STUDENT_EDIT_GRADUATION, _ctx.Permission.STUDENT]]
                  ])
            ])
          ], 2),
          (_ctx.dataCustomer.id && (_ctx.infUser?.role == 1 || _ctx.infUser?.role == 3))
            ? (_openBlock(), _createBlock(_component_WidgetStaffLecturerChild, {
                key: 0,
                class: "mb-5 mb-xl-8",
                dataCustomer: _ctx.dataCustomer,
                idStudent: _ctx.route.params.id
              }, null, 8, ["dataCustomer", "idStudent"]))
            : _createCommentVNode("", true),
          (_ctx.dataCustomer.id && (_ctx.infUser?.role == 1 || _ctx.infUser?.role == 3))
            ? (_openBlock(), _createBlock(_component_WidgetAssignUserGroup, {
                key: 1,
                class: "mb-5 mb-xl-8",
                dataCustomer: _ctx.dataCustomer,
                idStudent: _ctx.route.params.id
              }, null, 8, ["dataCustomer", "idStudent"]))
            : _createCommentVNode("", true),
          _createVNode(_component_WidgetComment, {
            class: "mb-5 mb-xl-8",
            idStudent: _ctx.route.params.id
          }, null, 8, ["idStudent"]),
          _createVNode(_component_WidgetAssign, {
            dataCustomer: _ctx.dataCustomer,
            class: "mb-5 mb-xl-8"
          }, null, 8, ["dataCustomer"]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_84, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-light-danger w-100",
              disabled: !!_ctx.deleteBlockedText,
              title: _ctx.deleteBlockedText || 'Xóa mềm ứng viên (có thể khôi phục)',
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.callModalDelete && _ctx.callModalDelete(...args)))
            }, [
              _createElementVNode("span", _hoisted_86, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
              ]),
              _createTextVNode(" Xóa ứng viên ")
            ], 8, _hoisted_85),
            (_ctx.deleteBlockedText)
              ? (_openBlock(), _createElementBlock("div", _hoisted_87, _toDisplayString(_ctx.deleteBlockedText), 1))
              : _createCommentVNode("", true)
          ])), [
            [_directive_permission, [_ctx.Permission.STUDENT_DELETE, _ctx.Permission.STUDENT]]
          ])
        ]),
        _createElementVNode("div", _hoisted_88, [
          (_ctx.gradWarningList().length && !_ctx.isOnlyArticulation)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "d-flex align-items-center bg-light-danger border border-danger border-dashed rounded px-4 py-3 mb-4 cursor-pointer",
                title: "Bấm để mở tab Thông tin học tập — mục Bảng điểm thi tốt nghiệp",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goGradScoreCard()))
              }, [
                _hoisted_89,
                _createElementVNode("div", _hoisted_90, [
                  _hoisted_91,
                  _createTextVNode(" " + _toDisplayString(_ctx.gradWarningList().join(' · ')) + " ", 1),
                  _hoisted_92
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("ul", _hoisted_93, [
            _createElementVNode("li", _hoisted_94, [
              _createElementVNode("a", {
                class: "nav-link btn btn-active-light-primary btn-color-gray-600 fw-semibold fs-6 px-4 py-2 active",
                "data-bs-toggle": "tab",
                href: "#kt_customer_view_learning_infor",
                ref: "click_view_learning_infor",
                onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.isTabs3 = false; _ctx.activeTabKey = 'learning'})
              }, "Thông tin học tập", 512)
            ]),
            _createElementVNode("li", _hoisted_95, [
              _createElementVNode("a", {
                class: "nav-link btn btn-active-light-primary btn-color-gray-600 fw-semibold fs-6 px-4 py-2",
                "data-bs-toggle": "tab",
                ref: "click_view_personal_infor",
                href: "#kt_customer_view_personal_infor",
                onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.isTabs3 = false; _ctx.activeTabKey = 'personal'})
              }, "Thông tin cá nhân", 512)
            ]),
            _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_96, [
              _createElementVNode("a", {
                class: "nav-link btn btn-active-light-primary btn-color-gray-600 fw-semibold fs-6 px-4 py-2",
                "data-kt-countup-tabs": "true",
                "data-bs-toggle": "tab",
                ref: "click_view_admission_profile",
                href: "#kt_customer_view_admission_profile",
                onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.isTabs3 = true; _ctx.activeTabKey = 'profile';})
              }, " Hồ sơ đăng ký xét ", 512)
            ])), [
              [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_VIEW, _ctx.Permission.ADMISSION_REGISTER]]
            ]),
            _createElementVNode("li", _hoisted_97, [
              _createElementVNode("a", {
                class: "nav-link btn btn-active-light-primary btn-color-gray-600 fw-semibold fs-6 px-4 py-2",
                "data-bs-toggle": "tab",
                href: "#kt_customer_view_admission_procedures",
                onClick: _cache[17] || (_cache[17] = ($event: any) => {_ctx.isTabs3 = true; _ctx.activeTabKey = 'procedures'})
              }, "Hồ sơ nhập học")
            ]),
            _createElementVNode("li", {
              class: _normalizeClass(["nav-item ms-auto d-flex align-items-center gap-2 pb-2", _ctx.activeTabKey === 'profile' ? '' : 'd-none'])
            }, [
              _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                class: _normalizeClass(["btn btn-sm btn-light-primary", _ctx.hasArticulation ? 'd-none' : '']),
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.addArticulationProfile()))
              }, [
                _createElementVNode("span", _hoisted_98, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen035.svg" })
                ]),
                _createTextVNode(" Thêm hồ sơ liên thông ")
              ], 2)), [
                [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_CREATE, _ctx.Permission.ADMISSION_REGISTER]]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "btn btn-sm btn-primary",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.addAdmissionProfile($event)))
              }, [
                _createElementVNode("span", _hoisted_99, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen035.svg" })
                ]),
                _createTextVNode(" Thêm hồ sơ ")
              ])), [
                [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_CREATE, _ctx.Permission.ADMISSION_REGISTER]]
              ])
            ], 2),
            _withDirectives((_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["nav-item ms-auto d-flex align-items-center gap-2 pb-2", (_ctx.activeTabKey === 'personal' || _ctx.activeTabKey === 'learning') ? '' : 'd-none'])
            }, [
              _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                class: _normalizeClass(["btn btn-sm btn-light-primary umt-btn-32", !_ctx.isEdit ? '' : 'd-none']),
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.isEditFunction && _ctx.isEditFunction(...args)))
              }, [
                _createElementVNode("span", _hoisted_100, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ]),
                _createTextVNode(" Chỉnh sửa ")
              ], 2)), [
                [_directive_permission, [_ctx.Permission.STUDENT_EDIT, _ctx.Permission.STUDENT]]
              ]),
              (_ctx.isEdit)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-light umt-btn-32",
                      onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.cancelEditTab && _ctx.cancelEditTab(...args)))
                    }, "Hủy bỏ"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-primary umt-btn-32",
                      onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.saveEditTab && _ctx.saveEditTab(...args)))
                    }, [
                      _hoisted_101,
                      _createTextVNode("Lưu thay đổi ")
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ], 2)), [
              [_directive_permission, [_ctx.Permission.STUDENT_VIEW, _ctx.Permission.STUDENT]]
            ])
          ]),
          (_ctx.dataCustomer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                _createElementVNode("div", _hoisted_103, [
                  _createVNode(_component_PersonalInfor, {
                    ref: "personalInfor",
                    "data-customer": _ctx.dataCustomer,
                    "is-edit": _ctx.isEdit,
                    onChangeEdit: _ctx.changeEditAdmissionStudent,
                    onBeforeSave: _ctx.mergeBeforeSave
                  }, null, 8, ["data-customer", "is-edit", "onChangeEdit", "onBeforeSave"]),
                  _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(!_ctx.isEdit ? 'd-flex justify-content-end px-4 pb-8' : 'd-none')
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-light-primary umt-btn-32",
                      onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.isEditFunction && _ctx.isEditFunction(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_104, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                      ]),
                      _createTextVNode(" Chỉnh sửa ")
                    ])
                  ], 2)), [
                    [_directive_permission, [_ctx.Permission.STUDENT_EDIT, _ctx.Permission.STUDENT]]
                  ])
                ]),
                _createElementVNode("div", _hoisted_105, [
                  _createVNode(_component_LearningInfor, {
                    ref: "learningInfor",
                    "card-classes": "mb-6 mb-xl-9",
                    onChangeEdit: _ctx.changeEditAdmissionStudent,
                    onBeforeSave: _ctx.mergeBeforeSave,
                    "data-customer": _ctx.dataCustomer,
                    "is-edit": _ctx.isEdit,
                    "is-only-articulation": _ctx.isOnlyArticulation,
                    "data-applicant": _ctx.dataApplicant
                  }, null, 8, ["onChangeEdit", "onBeforeSave", "data-customer", "is-edit", "is-only-articulation", "data-applicant"]),
                  _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(!_ctx.isEdit ? 'd-flex justify-content-end px-4 pb-8' : 'd-none')
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-light-primary umt-btn-32",
                      onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.isEditFunction && _ctx.isEditFunction(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_106, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                      ]),
                      _createTextVNode(" Chỉnh sửa ")
                    ])
                  ], 2)), [
                    [_directive_permission, [_ctx.Permission.STUDENT_EDIT, _ctx.Permission.STUDENT]]
                  ])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_107, [
                  _createVNode(_component_AdmissionProfile, {
                    ref: "admissionProfileComp",
                    onCallbackFunction: _ctx.checkHighschoolGraduation,
                    onReload: _cache[25] || (_cache[25] = ($event: any) => {_ctx.getAdmission(_ctx.$route.params.id); _ctx.getScholarship(_ctx.$route.params.id)}),
                    highschoolGraduation: _ctx.submithighschoolGraduation,
                    "data-admission": _ctx.dataAdmission,
                    "priority-score": _ctx.dataCustomer.priorityScore,
                    "data-customer": _ctx.dataCustomer,
                    "order-number": _ctx.dataCustomer.orderNumber,
                    "card-classes": "mb-6 mb-xl-9"
                  }, null, 8, ["onCallbackFunction", "highschoolGraduation", "data-admission", "priority-score", "data-customer", "order-number"]),
                  (_ctx.scholarshipList.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                        _hoisted_109,
                        _hoisted_110,
                        _createElementVNode("div", _hoisted_111, [
                          _createElementVNode("table", _hoisted_112, [
                            _hoisted_113,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scholarshipList, (s) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: s.id,
                                  class: "text-gray-800"
                                }, [
                                  _createElementVNode("td", _hoisted_114, _toDisplayString(s.regScholarshipName ? `${s.regScholarshipName}${s.regScholarshipCode ? ` (${s.regScholarshipCode})` : ''}` : '—'), 1),
                                  _createElementVNode("td", null, _toDisplayString((_ctx.schGrant(s).description || _ctx.schGrant(s).scholarshipType || s.issuedScholarshipName) ? `${_ctx.schGrant(s).description || _ctx.schGrant(s).scholarshipType || s.issuedScholarshipName}${(_ctx.schGrant(s).scholarshipCode || s.issuedScholarshipCode) ? ` (${_ctx.schGrant(s).scholarshipCode || s.issuedScholarshipCode})` : ''}` : '—'), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.schGrant(s).majorName || s.majorName || _ctx.schGrant(s).majorCode || s.majorCode || '—'), 1),
                                  _createElementVNode("td", null, [
                                    (_ctx.schGrant(s).scholarshipValue)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_115, _toDisplayString(_ctx.fmtMoney(_ctx.schGrant(s).scholarshipValue)) + "đ", 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_116, "—")),
                                    (_ctx.schGrant(s).rate != null)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_117, " · " + _toDisplayString(Math.round(Number(_ctx.schGrant(s).rate) * 100)) + "%", 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", null, [
                                    ((_ctx.schGrant(s).issuedNo || s.issuedNo) || (_ctx.schGrant(s).issuedDate || s.issuedDate))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(_ctx.schGrant(s).issuedNo || s.issuedNo), 1),
                                          (_ctx.schGrant(s).issuedDate || s.issuedDate)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_118, " · " + _toDisplayString(_ctx.fmtScholarshipDate(_ctx.schGrant(s).issuedDate || s.issuedDate)), 1))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode("—")
                                        ], 64))
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass('badge badge-light-' + _ctx.scholarshipStatusBadge(s.status)[0])
                                    }, _toDisplayString(_ctx.scholarshipStatusBadge(s.status)[1]), 3)
                                  ]),
                                  _createElementVNode("td", _hoisted_119, [
                                    (_ctx.dataAdmission && _ctx.dataAdmission.length)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (s.status == 'new' || s.status == 'pending')
                                            ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "btn btn-sm btn-icon btn-light-success me-2",
                                                title: "Phê duyệt học bổng",
                                                onClick: ($event: any) => (_ctx.gotoApproveScholarship(s))
                                              }, _hoisted_122, 8, _hoisted_120)), [
                                                [_directive_permission, [_ctx.Permission.SCHOLARSHIP_APPROVE, _ctx.Permission.SCHOLARSHIP]]
                                              ])
                                            : _createCommentVNode("", true),
                                          _withDirectives((_openBlock(), _createElementBlock("span", {
                                            class: "btn btn-sm btn-icon btn-light btn-active-light-primary me-2",
                                            title: "Xem / chỉnh sửa học bổng đăng ký",
                                            onClick: ($event: any) => (_ctx.openScholarshipDrawer(s))
                                          }, _hoisted_125, 8, _hoisted_123)), [
                                            [_directive_permission, [_ctx.Permission.SCHOLARSHIP_VIEW, _ctx.Permission.SCHOLARSHIP]]
                                          ]),
                                          (s.status == 'new')
                                            ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                                key: 1,
                                                class: "btn btn-sm btn-icon btn-light btn-active-light-danger",
                                                title: "Xóa đăng ký học bổng",
                                                onClick: ($event: any) => (_ctx.deleteScholarshipReg(s))
                                              }, _hoisted_128, 8, _hoisted_126)), [
                                                [_directive_permission, [_ctx.Permission.SCHOLARSHIP_APPROVE, _ctx.Permission.SCHOLARSHIP]]
                                              ])
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_129, "Cần có hồ sơ"))
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ScholarshipRegisterDrawer, {
                    ref: "scholarshipRegisterDrawer",
                    onSaved: _cache[26] || (_cache[26] = ($event: any) => (_ctx.getScholarship(_ctx.$route.params.id)))
                  }, null, 512),
                  _createVNode(_component_ScholarshipApproveModal, {
                    ref: "scholarshipApproveModal",
                    onSaved: _cache[27] || (_cache[27] = ($event: any) => (_ctx.getScholarship(_ctx.$route.params.id)))
                  }, null, 512)
                ])), [
                  [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_VIEW, _ctx.Permission.ADMISSION_REGISTER]]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_130, [
                  _createElementVNode("div", _hoisted_131, [
                    _createVNode(_component_AdmissionProcedures, {
                      onCallbackFunction: _ctx.checkHighschoolGraduation,
                      highschoolGraduation: _ctx.dataCustomer.highschoolGraduation,
                      "data-applicant": _ctx.dataApplicant,
                      "priority-score": _ctx.dataCustomer.priorityScore,
                      "data-customer": _ctx.dataCustomer,
                      "card-classes": "mb-6 mb-xl-9"
                    }, null, 8, ["onCallbackFunction", "highschoolGraduation", "data-applicant", "priority-score", "data-customer"])
                  ]),
                  _createElementVNode("div", _hoisted_132, [
                    _hoisted_133,
                    _createElementVNode("div", _hoisted_134, [
                      _createElementVNode("div", _hoisted_135, [
                        _createElementVNode("div", _hoisted_136, [
                          _hoisted_137,
                          _createElementVNode("div", _hoisted_138, [
                            _createElementVNode("div", _hoisted_139, [
                              _createElementVNode("span", _hoisted_140, [
                                _createElementVNode("span", _hoisted_141, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/user.svg" })
                                ])
                              ]),
                              _createElementVNode("input", {
                                type: "text",
                                readonly: "",
                                class: "form-control",
                                value: _ctx.dataCustomer.email,
                                placeholder: "Email",
                                style: {"max-height":"40px"}
                              }, null, 8, _hoisted_142)
                            ]),
                            _hoisted_143,
                            _createElementVNode("div", _hoisted_144, [
                              _createElementVNode("span", _hoisted_145, [
                                _createElementVNode("span", _hoisted_146, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/user.svg" })
                                ])
                              ]),
                              _createElementVNode("input", {
                                type: "text",
                                readonly: "",
                                class: "form-control",
                                value: _ctx.dataCustomer.idCard,
                                placeholder: "CCCD",
                                style: {"max-height":"40px"}
                              }, null, 8, _hoisted_147)
                            ])
                          ])
                        ]),
                        _hoisted_148,
                        _createElementVNode("div", _hoisted_149, [
                          _createElementVNode("div", _hoisted_150, [
                            _createElementVNode("span", _hoisted_151, [
                              _createElementVNode("span", _hoisted_152, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/lock.svg" })
                              ])
                            ]),
                            _createElementVNode("input", {
                              id: "textPassword",
                              type: "password",
                              readonly: "",
                              class: "form-control border-end-0",
                              value: _ctx.passwordStudent,
                              style: {"max-height":"40px"}
                            }, null, 8, _hoisted_153),
                            _createElementVNode("span", {
                              class: "input-group-text bg-transparent",
                              onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args))),
                              style: {"cursor":"pointer"}
                            }, [
                              _createElementVNode("span", _hoisted_154, [
                                (_ctx.passwordView == 'password')
                                  ? (_openBlock(), _createBlock(_component_inline_svg, {
                                      key: 0,
                                      src: "/media/icons/duotune/customer/hidden.svg"
                                    }))
                                  : (_openBlock(), _createBlock(_component_inline_svg, {
                                      key: 1,
                                      src: "/media/icons/duotune/customer/visible.svg"
                                    }))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_155, [
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-light-primary me-3 mb-3",
                            onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.renderPassword && _ctx.renderPassword(...args)))
                          }, [
                            _createElementVNode("span", _hoisted_156, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/edit.svg" })
                            ]),
                            _createTextVNode(" Tạo mật khẩu mới ")
                          ])
                        ])
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-light-primary me-3 mb-3",
                        onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.sendPasswordByMail && _ctx.sendPasswordByMail(...args)))
                      }, [
                        _createElementVNode("span", _hoisted_157, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/mail-send.svg" })
                        ]),
                        _createTextVNode(" Gửi mật khẩu qua email cho ứng viên ")
                      ])
                    ])
                  ])
                ])), [
                  [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_VIEW, _ctx.Permission.ADMISSION_REGISTER]]
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_ModalDeleteAndReason, {
      ref: "callFunctionModal",
      title: "Xác nhận xóa ứng viên này",
      id: "auth_delete_candidate",
      "warning-text": "Ứng viên và các hồ sơ đăng ký xét tuyển bên dưới sẽ được ĐÁNH DẤU ĐÃ XÓA (xóa mềm — có thể khôi phục ở danh sách đã xóa). KHÔNG xóa hồ sơ nhập học và KHÔNG gỡ dữ liệu đã đẩy lên Salesforce.",
      "warning-items": _ctx.dataAdmission,
      "blocked-text": _ctx.deleteBlockedText,
      onCallBackDelete: _ctx.isDeleteFunction
    }, null, 8, ["warning-items", "blocked-text", "onCallBackDelete"]),
    _createVNode(_component_ModalChooseMajor, {
      ref: "callFunctionModalChooseMajor",
      title: "Chọn ngành để nhập học",
      id: "ele_choose_major",
      onCallBackFunc: _ctx.chooseMajorFunction,
      arrMajor: _ctx.chooseMajor.map((i)=> ({...i, label: i.adMajor,value: i.admissionwinnerid}))
    }, null, 8, ["onCallBackFunc", "arrMajor"]),
    _createVNode(_component_ModalChooseApplicants, {
      ref: "callFunctionModalChooseApplicants",
      title: "Tạo mã sinh viên",
      id: "ele_choose_applicants",
      onCallBackFunc: _ctx.syncRow
    }, null, 8, ["onCallBackFunc"]),
    _createVNode(_component_ModalRunAnalysis, {
      priorityScore: _ctx.dataCustomer.priorityScore,
      ref: "callFunctionModalRunAnalysis",
      id: "ele_choose_adm",
      title: "Chọn hồ sơ để analysis",
      onCallBackFunc: _ctx.syncWithIDDoc,
      arrMajor: _ctx.dataAdmission.map((i)=> ({...i, label: `${i.code} - Đợt ${i.phase} - ${i.method}`,value: i.id}))
    }, null, 8, ["priorityScore", "onCallBackFunc", "arrMajor"]),
    _createVNode(_component_ModalEditInput, {
      ref: "callFunctionEditField",
      title: "Edit",
      label: _ctx.crmField,
      id: "edit_fields_CRM",
      onCallBackFunc: _ctx.funcEditCRM,
      dataCustomer: _ctx.dataCustomer
    }, null, 8, ["label", "onCallBackFunc", "dataCustomer"])
  ], 64))
}